module.exports = __webpack_public_path__ + "img/Kinfolk-Circle-Vector.2d6b6af7.svg";